var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Motorista","titleIcon":"fas fa-id-badge"}},[_c('form-motorista',{attrs:{"paramId":_vm.id},on:{"onSubmitMotorista":_vm.afterSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }